import React, { useEffect } from 'react';
import { Page } from '../../components/atoms/layout/Page';
import { observer, useLocalStore } from 'mobx-react';
import { LessonHomeworkSubmissionPageState } from './states/LessonHomeworkSubmissionPageState';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { NotFoundPage } from '../../../mainv2/containers/common/NotFoundPage';
import { useNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { LessonHomeworkHeader } from '../../components/organisms/lesson_homeworks/LessonHomeworkHeader';
import { LessonHomeworkSubmissionForm } from '../../components/organisms/lesson_homeworks/LessonHomeworkSubmissionForm';
import './lessonHomeworkSubmissionPage.module.scss';

type Props = {
    match: {
        params: {
            homeworkId: string;
        };
    };
};

export const LessonHomeworkSubmissionPage = observer(({ match: { params: { homeworkId } } }: Props) => {
    useNavigation(NavigationSpecs.home('mint-green'));
    const { pageState } = useLocalStore(() => {
        return {
            pageState: new LessonHomeworkSubmissionPageState(),
        };
    });
    useEffect(
        () => {
            pageState.init(Number(homeworkId));
        },
        [homeworkId]
    );
    const {
        homework: homeworkResource,
        fieldStates,
        submit,
        submitState: { submitting },
    } = pageState;
    if (homeworkResource.loading) {
        return <LoaderRow />;
    }
    if (homeworkResource.isEmpty()) {
        return <NotFoundPage entityType="宿題" />;
    }
    const homework = homeworkResource.getOrThrow();
    return (
        <Page id="lesson-homework-submission-page" styleName="page">
            <LessonHomeworkHeader homework={homework} showReviewer={false} />
            <div styleName="body-wrapper">
                <div styleName="body">
                    {homework.submission_notice && (
                        <div
                            styleName="homework-submission-notice"
                            id="homework-submission-notice"
                            dangerouslySetInnerHTML={{ __html: homework.submission_notice }}
                        />
                    )}
                    <LessonHomeworkSubmissionForm fields={fieldStates} loading={submitting} onSubmit={submit} />
                </div>
            </div>
        </Page>
    );
});
